<form [formGroup]="form" (ngSubmit)="addRecord()">
  <lin-layout-form-sections-wrapper layout="double">
    <lin-layout-form-section>
      <h2>
        {{ (document ? 'CLIENT.VEHICLES.DOCUMENTS.ADD_DOCUMENT_RECORD' : 'CLIENT.VEHICLES.DOCUMENTS.CREATE_DOCUMENT_RECORD') | translate }}
      </h2>

      <lin-form-label required>{{ 'CLIENT.VEHICLES.DOCUMENTS.ISSUE_DATE' | translate }}</lin-form-label>
      <lin-datepicker-field
        formControlName="issueDate"
        [isPlaceholderShown]="true"
        [isDisabled]="isRecordAdding"
        [isNoMaxDate]="true"
      ></lin-datepicker-field>

      <mat-checkbox class="form-checkbox" formControlName="noExpiry">
        {{ 'CLIENT.VEHICLES.DOCUMENTS.NO_EXPIRY' | translate }}
      </mat-checkbox>

      <lin-form-label [required]="!isNotExpiring">{{ 'FIELDS.expirationDate' | translate }}</lin-form-label>
      <lin-datepicker-field
        formControlName="expDate"
        [isNoMaxDate]="true"
        [isPlaceholderShown]="true"
        [isDisabled]="isNotExpiring || isRecordAdding"
        [minDate]="issueDateIsValid ? issueDate.add(1, 'day').format('YYYY/MM/DD HH:mm') : ''"
        [isError]="issueDateIsValid && form?.get('expDate')?.value && !expDateIsValid"
      ></lin-datepicker-field>
      @if (issueDateIsValid && form?.get('expDate')?.value && !expDateIsValid) {
      <mat-error class="lin-autocomplete-error">{{ 'ERRORS.EXP_DATE_NOT_VALID' | translate }}</mat-error>
      }

      <lin-form-submit-button
        class="add-document-button record-button-md"
        [isDisabled]="isSubmitDocumentDisabled()"
        [isLoading]="isRecordAdding"
      >
        {{ (document ? 'CLIENT.VEHICLES.DOCUMENTS.ADD_DOCUMENT_RECORD' : 'CLIENT.VEHICLES.DOCUMENTS.CREATE_DOCUMENT_RECORD') | translate }}
      </lin-form-submit-button>
    </lin-layout-form-section>

    <lin-layout-form-section>
      <lin-form-label class="cost" [currencyLabel]="true">{{ 'CLIENT.VEHICLES.SERVICE_REMINDERS.COST' | translate }}</lin-form-label>
      <mat-form-field>
        <input matInput formControlName="cost" type="number" min="0" autocomplete="off" />
        <mat-error><lin-form-field-error></lin-form-field-error></mat-error>
      </mat-form-field>

      <lin-form-label>{{ 'FIELDS.NOTE' | translate }}</lin-form-label>
      <mat-form-field>
        <textarea matInput rows="7" formControlName="note"></textarea>
      </mat-form-field>

      <lin-form-file-picker formControlName="files"> </lin-form-file-picker>

      <lin-form-submit-button
        class="add-document-button record-button-sm"
        [isDisabled]="isSubmitDocumentDisabled()"
        [isLoading]="isRecordAdding"
      >
        {{ (document ? 'CLIENT.VEHICLES.DOCUMENTS.ADD_DOCUMENT_RECORD' : 'CLIENT.VEHICLES.DOCUMENTS.CREATE_DOCUMENT_RECORD') | translate }}
      </lin-form-submit-button>
    </lin-layout-form-section>
  </lin-layout-form-sections-wrapper>
</form>
